module.exports = __webpack_public_path__ + "img/pCardUs3.b88bc84a.png";